module.exports = __webpack_public_path__ + "officialStatic/img/case50.967b41f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case50.jpg
// module id = x1cF
// module chunks = 0